// ── Shift moves (Overtime Policy 2.b, 3.b, 3.e) ─────────────────────────────
//
// Usual hours are 7am to 6pm. A shift moved so that any of it falls outside
// them is paid at the base hourly rate plus 25%. It is not overtime: the same
// hours, moved, so it never goes through overtime rates and the uplift is never
// added to overtime hours. Payroll needs, per person and day, that the shift
// was moved and how long it was; the start and end times settle both.
//
// The PLOW's shift time row is where a shift is planned, so that row carries
// the two times. Nearly every shift is 8am to 4pm, so that is the default a
// planner starts from and only changes when the shift really has moved.
//
// Pure functions of HH:MM strings. Shared by the PLOW cell editor (to show a
// planner the uplift coming), the PLOW API (to validate what is saved) and the
// overtime ledger (to cost it).

export const USUAL_HOURS_START = '07:00';
export const USUAL_HOURS_END = '18:00';
export const DEFAULT_SHIFT_START = '08:00';
export const DEFAULT_SHIFT_END = '16:00';
export const SHIFT_MOVE_UPLIFT = 0.25;

const TIME = /^([01]\d|2[0-3]):[0-5]\d$/;

/** True for a 24 hour HH:MM string. */
export function isValidTime(value) {
  return typeof value === 'string' && TIME.test(value);
}

const minutes = (hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
};

/** Length of a shift in hours, to two decimals. A shift ending at or before it starts runs into the next day. */
export function shiftHours(start, end) {
  if (!isValidTime(start) || !isValidTime(end)) return 0;
  let span = minutes(end) - minutes(start);
  if (span < 0) span += 24 * 60;
  return Math.round((span / 60 + Number.EPSILON) * 100) / 100;
}

/** Whether a shift falls, in any part, outside the policy's usual hours. */
export function isShiftMove(start, end) {
  if (!isValidTime(start) || !isValidTime(end)) return false;
  const s = minutes(start);
  const e = minutes(end);
  if (e < s) return true;   // over midnight is always outside 7am to 6pm
  return s < minutes(USUAL_HOURS_START) || e > minutes(USUAL_HOURS_END);
}
